"use strict";var e=require("./InputMask.cjs"),r=require("./useMask.cjs");require("react"),require("@react-input/core"),exports.InputMask=e,exports.useMask=r;
